import { create } from 'zustand'
import { useAccountMatterStore } from './use-account-matter-store';

type MatterEntityDetailsAdminStore = {
  firmInfo: Record<string, { name?: string; users: { id?: string; name?: string; email?: string }[] }>
  matterInfo: Record<string, {
    number?: string;
    title?: string;
    description?: string;
  }>
}

export const useMatterEntityDetailsAdminStore = create<MatterEntityDetailsAdminStore>(() => ({
  firmInfo: {},
  matterInfo: {},
}));

const fetchData = async () => {
  const { accountId, matterId } = useAccountMatterStore.getState();

  if (!accountId) {
    return;
  }

  const { firmInfo, matterInfo } = useMatterEntityDetailsAdminStore.getState();

  try {
    if (matterId && !matterInfo[matterId]) {
      const response = await fetch(`/api/matter/admin/matter-entity-info?matterId=${matterId}&accountId=${accountId}`)
      if (!response.ok) {
        throw new Error('Something went wrong trying to admin matter entity info')
      }
      const data = (await response.json()) as {
        number?: string;
        title?: string;
        description?: string;
      }
      useMatterEntityDetailsAdminStore.setState({ matterInfo: { ...matterInfo, [matterId]: data } });
    }

    if (!firmInfo[accountId]) {
      const response = await fetch(`/api/matter/admin/firm-entity-info?accountId=${accountId}`)
      if (!response.ok) {
        throw new Error('Something went wrong trying to get admin firm entity info')
      }
      const data = (await response.json()) as {
        name?: string
        users: {
          id?: string
          name?: string
          email?: string
        }[]
      }
      useMatterEntityDetailsAdminStore.setState({ firmInfo: { ...firmInfo, [accountId]: data } });
    }
  } catch (err) {
    if (err instanceof Error) {
      console.warn("Error fetching firm/matter data", err)
    }
  }
}

// we need to subscribe to the useAccountMatterStore to see accountId/matterId changes
const subscribeToAccountId = () => {
  const unsubscribe = useAccountMatterStore.subscribe(
    (state, prevState) => {
      if (state.accountId !== prevState.accountId || state.matterId !== prevState.matterId) {
        fetchData().catch((err) => {
          console.error('Error fetching feature flags:', err);
        });
      }
    }
  );

  // Return cleanup function
  return () => {
    // Unsubscribe from the store
    unsubscribe();
  };
}


export const initMatterEntityDetailsAdminStore = () => {
  const disableAccountSub = subscribeToAccountId();
  fetchData();

  return [disableAccountSub];
}
